module.exports = __webpack_public_path__ + "static/media/13C.f7965013.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/13C.svg
// module id = 45
// module chunks = 0